import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const SuitcaseSolid = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M23.9589 4.83732H18.0124V3.28212C18.0103 1.76688 16.7834 0.539998 15.2682 0.536758H11.6102C10.095 0.538918 8.86809 1.76688 8.86485 3.28104V4.83624H2.91837C1.30593 4.83732 -0.00195312 6.14412 -0.00195312 7.75764V22.0741V22.0784C-0.00195312 23.6898 1.30377 24.9955 2.91513 24.9955H2.91837H3.77481C3.77157 25.029 3.77049 25.069 3.77049 25.1078C3.77049 25.9189 4.42821 26.5766 5.23929 26.5766C6.05037 26.5766 6.70809 25.9189 6.70809 25.1078C6.70809 25.0679 6.70701 25.029 6.70377 24.9901V24.9955H20.1562C20.1562 25.8044 20.8118 26.46 21.6207 26.46C22.4296 26.46 23.0852 25.8044 23.0852 24.9955H23.9416H23.9449C25.5562 24.9955 26.862 23.6898 26.862 22.0784C26.862 22.0774 26.862 22.0752 26.862 22.0741V7.75764C26.862 7.75116 26.862 7.74252 26.862 7.73388C26.862 6.13332 25.5649 4.83624 23.9643 4.83624C23.9622 4.83624 23.9589 4.83624 23.9568 4.83624L23.9589 4.83732ZM10.9071 3.28212C10.9071 2.89332 11.2225 2.57796 11.6113 2.57796H15.2682C15.657 2.57796 15.9723 2.89332 15.9723 3.28212V4.83732H10.9147V3.28212H10.9071ZM6.01797 21.8797C4.70577 21.8797 3.63981 20.8159 3.63981 19.5026C3.63981 18.1894 4.70361 17.1256 6.01689 17.1256C7.32909 17.1256 8.39397 18.1894 8.39397 19.5026C8.39397 20.8148 7.33017 21.8786 6.01797 21.8797ZM9.88329 12.2893L11.4385 8.11296L15.6148 9.66816L14.0596 13.8456L9.88329 12.2893ZM16.6225 21.2922L15.59 17.7228L23.4405 15.458L24.473 19.0274L16.6225 21.2922Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 27 27">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { SuitcaseSolid };